import { useColorModeValue } from "@pathwright/ux/src/components/chakra/ui/color-mode"

function useColorModeBranding() {
  // Using default color scheme when in dark mode.
  return useColorModeValue("brand", undefined)
}

export default useColorModeBranding
